import actions from '../../actionTypes';

export default (siteId) => {
  return {
    type: actions.GET_LOCATIONS_BY_SITE,
    siteId
  };
};



// WEBPACK FOOTER //
// ./src/reducers/locations/actions/getLocationsBySite.js